import { React, useState, useEffect, useContext } from 'react'
import { CFormInput, CImage, CButton, CModal, CModalBody, CFormText } from '@coreui/react'
import { useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { TEMPLATE_V2_URL } from '../../utils/urls'
import { AppContext } from '../../context/app'
import DummyImg from '../../../assets/template-name-img.png'

const TemplateNameModal = ({ baseTemplateInfo, onCancel }) => {
  const history = useHistory()
  const { setLoader } = useContext(AppContext)
  const [projectTitle, setProjectTitle] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const limit = 35

  const [{ loading: createTemplateLoading }, createTemplateDataCall] = useAxios(
    {
      url: TEMPLATE_V2_URL,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(createTemplateLoading)
  }, [createTemplateLoading])

  const titleChangeHandler = (newVal) => {
    setErrorMsg('')
    setProjectTitle(newVal.substring(0, limit))
  }

  const validateInfo = () => {
    if (projectTitle.trim().length === 0) {
      setErrorMsg('Project title cannot be Empty!')
      return false
    }
    return true
  }

  const onSaveHandler = async () => {
    if (!validateInfo()) return

    const createTemplateData = await createTemplateDataCall({
      data: {
        name: projectTitle,
        base_template: baseTemplateInfo._id,
        selected_theme: baseTemplateInfo.default_theme,
        preview_s3_key: baseTemplateInfo.preview_s3_key,
      },
    })

    if (createTemplateData?.data?.success) {
      history.push(`/template-editor/${createTemplateData?.data?.data?._id}`)
    }
  }

  return (
    <CModal size="xl" visible={true} alignment="center" className="template-title-preview border-0">
      <CModalBody
        className="m-auto p-0"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <div className="p-5 d-flex flex-column justify-content-center align-items-start  rounded-0 bg-white">
          <h4>Give a title to your template project</h4>
          <p className=" text-secondary">
            <small>
              The template will be saved by the title you{"'"}ve given. It will be easy for your
              future access to your templates.
            </small>
          </p>
          <div className="mt-2 mb-5 w-100">
            <CFormInput
              type="text"
              id="floatingInput"
              floatingLabel="Project title"
              placeholder="Template project title"
              className=" border border-start-0 border-end-0 border-top-0 rounded-0 border-bottom-2 shadow-none p-1 w-75"
              value={projectTitle}
              onChange={(e) => titleChangeHandler(e.target.value)}
            />
            <div className={`d-flex justify-content-between w-75`}>
              <div className="message-text error-message">
                <p>{errorMsg}</p>
              </div>
              <CFormText
                style={{ color: projectTitle.length < limit ? 'black' : 'red', fontSize: '12px' }}
              >
                Characters : {projectTitle.length}/{limit}
              </CFormText>
            </div>
          </div>
          <div className="d-flex">
            <CButton
              className=" bg-black rounded-1 btn-focus-none"
              type="submit"
              onClick={onSaveHandler}
            >
              Save {'&'} Continue
            </CButton>
            <CButton
              className=" bg-black rounded-1 btn-focus-none mx-4"
              type="submit"
              onClick={onCancel}
            >
              Cancel
            </CButton>
          </div>
        </div>
        <CImage src={DummyImg} width="55%" height="100%" fluid align="end" />
      </CModalBody>
    </CModal>
  )
}

export default TemplateNameModal
